"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var isBrowser = typeof window !== 'undefined';

var getScrollPosition = function getScrollPosition(_ref) {
  var element = _ref.element,
      useWindow = _ref.useWindow;
  if (!isBrowser) return {
    x: 0,
    y: 0
  };
  var target = element ? element.current : document.body;
  var position = target.getBoundingClientRect();
  return useWindow ? {
    x: window.pageXOffset,
    y: window.pageYOffset
  } : {
    x: position.left,
    y: position.top
  };
};

var useScrollPosition = function useScrollPosition(effect, deps, element, useWindow, wait) {
  var position = (0, _react.useRef)(getScrollPosition({
    useWindow: useWindow
  }));
  var throttleTimeoutRef = (0, _react.useRef)(null);

  var callBack = function callBack() {
    var currentPosition = getScrollPosition({
      element: element,
      useWindow: useWindow
    });
    effect({
      previousPosition: position.current,
      currentPosition: currentPosition
    });
    position.current = currentPosition;
    throttleTimeoutRef.current = null;
  };

  (0, _react.useLayoutEffect)(function () {
    var handleScroll = function handleScroll() {
      if (wait) {
        if (throttleTimeoutRef.current === null) {
          throttleTimeoutRef.current = setTimeout(callBack, wait);
        }
      } else {
        callBack();
      }
    };

    window.addEventListener('scroll', handleScroll);
    return function () {
      return window.removeEventListener('scroll', handleScroll);
    };
  });
};

var _default = useScrollPosition; // useScrollPosition(({ prevPos, currPos }) => {
// const isShow = currPos.y > prevPos.y
// if (isShow !== hideOnScroll) setHideOnScroll(isShow)
// }, [hideOnScroll])

exports.default = _default;

//# sourceMappingURL=ScrollPositionHelper.js.map